import axios from "axios";
import authenticationInterceptor from "./AuthenticationInterceptor";
import { environment } from "../../../environments/environment";

axios.defaults.withCredentials = false;

export const authenticationRepository = axios.create({
  baseURL: environment.serverUrl,
  headers: authenticationInterceptor.getHeaders()
});
